"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trace API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraceApi = exports.TraceApiFactory = exports.TraceApiFp = exports.TraceApiAxiosParamCreator = exports.WorkspaceStatusEnum = exports.WorkspaceCurrencyEnum = exports.UserNotificationTypeEnum = exports.UpdateUserWorkspaceRequestRoleEnum = exports.UpdateOrderRequestStatusEnum = exports.TemplateIdEnum = exports.OrderStatusEnum = exports.NotificationTypeEnum = exports.InviteUsersRequestEmailsRoleEnum = exports.IMAGETypeEnum = exports.GetWidgetUploadUrlRequestWidgetTypeEnum = exports.GetOrderResponseStatusEnum = exports.GetDeliveryResponseStatusEnum = exports.GPSTypeEnum = exports.FILETypeEnum = exports.DocumentWithoutTemplateStatusEnum = exports.DocumentWidgetEnum = exports.DocumentUserNotificationTypeEnum = exports.DocumentRecipientNotificationTypeEnum = exports.DocumentStatusEnum = exports.DeliveryStatusEnum = exports.CreateWorkspaceRequestCurrencyEnum = exports.AdminUpdateWorkspaceRequestStatusEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AdminUpdateWorkspaceRequestStatusEnum;
(function (AdminUpdateWorkspaceRequestStatusEnum) {
    AdminUpdateWorkspaceRequestStatusEnum["Unpaid"] = "unpaid";
    AdminUpdateWorkspaceRequestStatusEnum["Trial"] = "trial";
    AdminUpdateWorkspaceRequestStatusEnum["ForeverFree"] = "forever-free";
    AdminUpdateWorkspaceRequestStatusEnum["Paid"] = "paid";
    AdminUpdateWorkspaceRequestStatusEnum["PastDue"] = "past-due";
    AdminUpdateWorkspaceRequestStatusEnum["Cancelled"] = "cancelled";
})(AdminUpdateWorkspaceRequestStatusEnum || (exports.AdminUpdateWorkspaceRequestStatusEnum = AdminUpdateWorkspaceRequestStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateWorkspaceRequestCurrencyEnum;
(function (CreateWorkspaceRequestCurrencyEnum) {
    CreateWorkspaceRequestCurrencyEnum["Nok"] = "nok";
    CreateWorkspaceRequestCurrencyEnum["Sek"] = "sek";
    CreateWorkspaceRequestCurrencyEnum["Aud"] = "aud";
    CreateWorkspaceRequestCurrencyEnum["Gbp"] = "gbp";
    CreateWorkspaceRequestCurrencyEnum["Usd"] = "usd";
})(CreateWorkspaceRequestCurrencyEnum || (exports.CreateWorkspaceRequestCurrencyEnum = CreateWorkspaceRequestCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DeliveryStatusEnum;
(function (DeliveryStatusEnum) {
    DeliveryStatusEnum["Scheduled"] = "SCHEDULED";
    DeliveryStatusEnum["InProgress"] = "IN_PROGRESS";
    DeliveryStatusEnum["Delivered"] = "DELIVERED";
    DeliveryStatusEnum["Rejected"] = "REJECTED";
})(DeliveryStatusEnum || (exports.DeliveryStatusEnum = DeliveryStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentStatusEnum;
(function (DocumentStatusEnum) {
    DocumentStatusEnum["Draft"] = "DRAFT";
    DocumentStatusEnum["Assigned"] = "ASSIGNED";
    DocumentStatusEnum["Completed"] = "COMPLETED";
})(DocumentStatusEnum || (exports.DocumentStatusEnum = DocumentStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentRecipientNotificationTypeEnum;
(function (DocumentRecipientNotificationTypeEnum) {
    DocumentRecipientNotificationTypeEnum["RecipientViewDocumentNotification"] = "RECIPIENT_VIEW_DOCUMENT_NOTIFICATION";
})(DocumentRecipientNotificationTypeEnum || (exports.DocumentRecipientNotificationTypeEnum = DocumentRecipientNotificationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentUserNotificationTypeEnum;
(function (DocumentUserNotificationTypeEnum) {
    DocumentUserNotificationTypeEnum["AssignDocumentNotification"] = "USER_ASSIGN_DOCUMENT_NOTIFICATION";
    DocumentUserNotificationTypeEnum["FinalizeDocumentNotification"] = "USER_FINALIZE_DOCUMENT_NOTIFICATION";
})(DocumentUserNotificationTypeEnum || (exports.DocumentUserNotificationTypeEnum = DocumentUserNotificationTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DocumentWidgetEnum;
(function (DocumentWidgetEnum) {
    DocumentWidgetEnum["Image"] = "IMAGE";
    DocumentWidgetEnum["File"] = "FILE";
    DocumentWidgetEnum["Gps"] = "GPS";
})(DocumentWidgetEnum || (exports.DocumentWidgetEnum = DocumentWidgetEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DocumentWithoutTemplateStatusEnum;
(function (DocumentWithoutTemplateStatusEnum) {
    DocumentWithoutTemplateStatusEnum["Draft"] = "DRAFT";
    DocumentWithoutTemplateStatusEnum["Assigned"] = "ASSIGNED";
    DocumentWithoutTemplateStatusEnum["Completed"] = "COMPLETED";
})(DocumentWithoutTemplateStatusEnum || (exports.DocumentWithoutTemplateStatusEnum = DocumentWithoutTemplateStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FILETypeEnum;
(function (FILETypeEnum) {
    FILETypeEnum["File"] = "FILE";
})(FILETypeEnum || (exports.FILETypeEnum = FILETypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GPSTypeEnum;
(function (GPSTypeEnum) {
    GPSTypeEnum["Gps"] = "GPS";
})(GPSTypeEnum || (exports.GPSTypeEnum = GPSTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetDeliveryResponseStatusEnum;
(function (GetDeliveryResponseStatusEnum) {
    GetDeliveryResponseStatusEnum["Scheduled"] = "SCHEDULED";
    GetDeliveryResponseStatusEnum["InProgress"] = "IN_PROGRESS";
    GetDeliveryResponseStatusEnum["Delivered"] = "DELIVERED";
    GetDeliveryResponseStatusEnum["Rejected"] = "REJECTED";
})(GetDeliveryResponseStatusEnum || (exports.GetDeliveryResponseStatusEnum = GetDeliveryResponseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetOrderResponseStatusEnum;
(function (GetOrderResponseStatusEnum) {
    GetOrderResponseStatusEnum["Scheduled"] = "SCHEDULED";
    GetOrderResponseStatusEnum["Approved"] = "APPROVED";
    GetOrderResponseStatusEnum["Preparing"] = "PREPARING";
    GetOrderResponseStatusEnum["ReadyToDispatch"] = "READY_TO_DISPATCH";
    GetOrderResponseStatusEnum["Dispatched"] = "DISPATCHED";
    GetOrderResponseStatusEnum["Rejected"] = "REJECTED";
})(GetOrderResponseStatusEnum || (exports.GetOrderResponseStatusEnum = GetOrderResponseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetWidgetUploadUrlRequestWidgetTypeEnum;
(function (GetWidgetUploadUrlRequestWidgetTypeEnum) {
    GetWidgetUploadUrlRequestWidgetTypeEnum["Image"] = "IMAGE";
    GetWidgetUploadUrlRequestWidgetTypeEnum["File"] = "FILE";
    GetWidgetUploadUrlRequestWidgetTypeEnum["Gps"] = "GPS";
})(GetWidgetUploadUrlRequestWidgetTypeEnum || (exports.GetWidgetUploadUrlRequestWidgetTypeEnum = GetWidgetUploadUrlRequestWidgetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IMAGETypeEnum;
(function (IMAGETypeEnum) {
    IMAGETypeEnum["Image"] = "IMAGE";
})(IMAGETypeEnum || (exports.IMAGETypeEnum = IMAGETypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InviteUsersRequestEmailsRoleEnum;
(function (InviteUsersRequestEmailsRoleEnum) {
    InviteUsersRequestEmailsRoleEnum["User"] = "user";
    InviteUsersRequestEmailsRoleEnum["Admin"] = "admin";
    InviteUsersRequestEmailsRoleEnum["Client"] = "client";
})(InviteUsersRequestEmailsRoleEnum || (exports.InviteUsersRequestEmailsRoleEnum = InviteUsersRequestEmailsRoleEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["RecipientViewDocumentNotification"] = "RECIPIENT_VIEW_DOCUMENT_NOTIFICATION";
    NotificationTypeEnum["UserFinalizeDocumentNotification"] = "USER_FINALIZE_DOCUMENT_NOTIFICATION";
    NotificationTypeEnum["UserAssignDocumentNotification"] = "USER_ASSIGN_DOCUMENT_NOTIFICATION";
    NotificationTypeEnum["NewUserNotification"] = "NEW_USER_NOTIFICATION";
    NotificationTypeEnum["UserGainPermissionToTemplate"] = "USER_GAIN_PERMISSION_TO_TEMPLATE";
    NotificationTypeEnum["UserLosePermissionToTemplate"] = "USER_LOSE_PERMISSION_TO_TEMPLATE";
    NotificationTypeEnum["UserGainAdminRole"] = "USER_GAIN_ADMIN_ROLE";
})(NotificationTypeEnum || (exports.NotificationTypeEnum = NotificationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["Scheduled"] = "SCHEDULED";
    OrderStatusEnum["Approved"] = "APPROVED";
    OrderStatusEnum["Preparing"] = "PREPARING";
    OrderStatusEnum["ReadyToDispatch"] = "READY_TO_DISPATCH";
    OrderStatusEnum["Dispatched"] = "DISPATCHED";
    OrderStatusEnum["Rejected"] = "REJECTED";
})(OrderStatusEnum || (exports.OrderStatusEnum = OrderStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TemplateIdEnum;
(function (TemplateIdEnum) {
    TemplateIdEnum["PressureTest"] = "pressure-test";
    TemplateIdEnum["QuickCapture"] = "quick-capture";
    TemplateIdEnum["Relining"] = "relining";
})(TemplateIdEnum || (exports.TemplateIdEnum = TemplateIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateOrderRequestStatusEnum;
(function (UpdateOrderRequestStatusEnum) {
    UpdateOrderRequestStatusEnum["Scheduled"] = "SCHEDULED";
    UpdateOrderRequestStatusEnum["Approved"] = "APPROVED";
    UpdateOrderRequestStatusEnum["Preparing"] = "PREPARING";
    UpdateOrderRequestStatusEnum["ReadyToDispatch"] = "READY_TO_DISPATCH";
    UpdateOrderRequestStatusEnum["Dispatched"] = "DISPATCHED";
    UpdateOrderRequestStatusEnum["Rejected"] = "REJECTED";
})(UpdateOrderRequestStatusEnum || (exports.UpdateOrderRequestStatusEnum = UpdateOrderRequestStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateUserWorkspaceRequestRoleEnum;
(function (UpdateUserWorkspaceRequestRoleEnum) {
    UpdateUserWorkspaceRequestRoleEnum["Admin"] = "admin";
    UpdateUserWorkspaceRequestRoleEnum["User"] = "user";
})(UpdateUserWorkspaceRequestRoleEnum || (exports.UpdateUserWorkspaceRequestRoleEnum = UpdateUserWorkspaceRequestRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserNotificationTypeEnum;
(function (UserNotificationTypeEnum) {
    UserNotificationTypeEnum["NewUserNotification"] = "NEW_USER_NOTIFICATION";
    UserNotificationTypeEnum["UserGainPermissionToTemplate"] = "USER_GAIN_PERMISSION_TO_TEMPLATE";
    UserNotificationTypeEnum["UserLosePermissionToTemplate"] = "USER_LOSE_PERMISSION_TO_TEMPLATE";
    UserNotificationTypeEnum["UserGainAdminRole"] = "USER_GAIN_ADMIN_ROLE";
})(UserNotificationTypeEnum || (exports.UserNotificationTypeEnum = UserNotificationTypeEnum = {}));
/**
 * The currency of the workspace
 * @export
 * @enum {string}
 */
var WorkspaceCurrencyEnum;
(function (WorkspaceCurrencyEnum) {
    WorkspaceCurrencyEnum["Sek"] = "sek";
    WorkspaceCurrencyEnum["Nok"] = "nok";
    WorkspaceCurrencyEnum["Aud"] = "aud";
    WorkspaceCurrencyEnum["Gbp"] = "gbp";
    WorkspaceCurrencyEnum["Usd"] = "usd";
})(WorkspaceCurrencyEnum || (exports.WorkspaceCurrencyEnum = WorkspaceCurrencyEnum = {}));
/**
 * The payment status of the workspace, useful for determining which restrictions (if any) should be applied
 * @export
 * @enum {string}
 */
var WorkspaceStatusEnum;
(function (WorkspaceStatusEnum) {
    WorkspaceStatusEnum["Unpaid"] = "unpaid";
    WorkspaceStatusEnum["Trial"] = "trial";
    WorkspaceStatusEnum["ForeverFree"] = "forever-free";
    WorkspaceStatusEnum["Paid"] = "paid";
    WorkspaceStatusEnum["PastDue"] = "past-due";
    WorkspaceStatusEnum["Cancelled"] = "cancelled";
})(WorkspaceStatusEnum || (exports.WorkspaceStatusEnum = WorkspaceStatusEnum = {}));
/**
 * TraceApi - axios parameter creator
 * @export
 */
const TraceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentImage: async (documentId, imageName, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling addDocumentImage.');
            }
            // verify required parameter 'imageName' is not null or undefined
            if (imageName === null || imageName === undefined) {
                throw new base_1.RequiredError('imageName', 'Required parameter imageName was null or undefined when calling addDocumentImage.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling addDocumentImage.');
            }
            const localVarPath = `/documents/{documentId}/image/{imageName}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"imageName"}}`, encodeURIComponent(String(imageName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Add a Widget to a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {DocumentWidgetEnum} widget The Widget to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentWidget: async (documentId, templateId, widget, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling addDocumentWidget.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling addDocumentWidget.');
            }
            // verify required parameter 'widget' is not null or undefined
            if (widget === null || widget === undefined) {
                throw new base_1.RequiredError('widget', 'Required parameter widget was null or undefined when calling addDocumentWidget.');
            }
            const localVarPath = `/documents/{documentId}/widget`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            if (widget !== undefined) {
                localVarQueryParameter['widget'] = widget;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin Add Workspace Trace Provider
         * @param {string} workspaceId ID of the Workspace
         * @param {AdminAddTraceProviderRequest} adminAddTraceProviderRequest Trace Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddWorkspaceTraceProvider: async (workspaceId, adminAddTraceProviderRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            if (workspaceId === null || workspaceId === undefined) {
                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling adminAddWorkspaceTraceProvider.');
            }
            // verify required parameter 'adminAddTraceProviderRequest' is not null or undefined
            if (adminAddTraceProviderRequest === null || adminAddTraceProviderRequest === undefined) {
                throw new base_1.RequiredError('adminAddTraceProviderRequest', 'Required parameter adminAddTraceProviderRequest was null or undefined when calling adminAddWorkspaceTraceProvider.');
            }
            const localVarPath = `/admin/workspaces/{workspaceId}/trace-provider`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof adminAddTraceProviderRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(adminAddTraceProviderRequest !== undefined ? adminAddTraceProviderRequest : {})
                : (adminAddTraceProviderRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary AdminGet All Workspaces
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllWorkspaces: async (limit, skip, options = {}) => {
            const localVarPath = `/admin/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin Get Workspace
         * @param {string} workspaceId ID of the Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWorkspace: async (workspaceId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            if (workspaceId === null || workspaceId === undefined) {
                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling adminGetWorkspace.');
            }
            const localVarPath = `/admin/workspaces/{workspaceId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin Update Workspace
         * @param {string} workspaceId ID of the Workspace
         * @param {AdminUpdateWorkspaceRequest} adminUpdateWorkspaceRequest Updated Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWorkspace: async (workspaceId, adminUpdateWorkspaceRequest, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            if (workspaceId === null || workspaceId === undefined) {
                throw new base_1.RequiredError('workspaceId', 'Required parameter workspaceId was null or undefined when calling adminUpdateWorkspace.');
            }
            // verify required parameter 'adminUpdateWorkspaceRequest' is not null or undefined
            if (adminUpdateWorkspaceRequest === null || adminUpdateWorkspaceRequest === undefined) {
                throw new base_1.RequiredError('adminUpdateWorkspaceRequest', 'Required parameter adminUpdateWorkspaceRequest was null or undefined when calling adminUpdateWorkspace.');
            }
            const localVarPath = `/admin/workspaces/{workspaceId}`
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof adminUpdateWorkspaceRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(adminUpdateWorkspaceRequest !== undefined ? adminUpdateWorkspaceRequest : {})
                : (adminUpdateWorkspaceRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Approve an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling approveOrder.');
            }
            const localVarPath = `/orders/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel the subscription for the workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (options = {}) => {
            const localVarPath = `/payments/subscription/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Clear a widget\'s data
         * @param {string} documentId Id of the document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ClearDocumentWidgetRequest} [clearDocumentWidgetRequest] An object containing the widget key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDocumentWidget: async (documentId, templateId, clearDocumentWidgetRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling clearDocumentWidget.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling clearDocumentWidget.');
            }
            const localVarPath = `/documents/{documentId}/widget/clear`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof clearDocumentWidgetRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(clearDocumentWidgetRequest !== undefined ? clearDocumentWidgetRequest : {})
                : (clearDocumentWidgetRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Confirm Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmDocumentImageRequest} confirmDocumentImageRequest Confirm Document Image Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentImage: async (documentId, imageName, templateId, confirmDocumentImageRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling confirmDocumentImage.');
            }
            // verify required parameter 'imageName' is not null or undefined
            if (imageName === null || imageName === undefined) {
                throw new base_1.RequiredError('imageName', 'Required parameter imageName was null or undefined when calling confirmDocumentImage.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling confirmDocumentImage.');
            }
            // verify required parameter 'confirmDocumentImageRequest' is not null or undefined
            if (confirmDocumentImageRequest === null || confirmDocumentImageRequest === undefined) {
                throw new base_1.RequiredError('confirmDocumentImageRequest', 'Required parameter confirmDocumentImageRequest was null or undefined when calling confirmDocumentImage.');
            }
            const localVarPath = `/documents/{documentId}/image/{imageName}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"imageName"}}`, encodeURIComponent(String(imageName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof confirmDocumentImageRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(confirmDocumentImageRequest !== undefined ? confirmDocumentImageRequest : {})
                : (confirmDocumentImageRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Confirm a Widget on a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmDocumentWidgetRequest} confirmDocumentWidgetRequest Confirm Widget Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentWidget: async (documentId, templateId, confirmDocumentWidgetRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling confirmDocumentWidget.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling confirmDocumentWidget.');
            }
            // verify required parameter 'confirmDocumentWidgetRequest' is not null or undefined
            if (confirmDocumentWidgetRequest === null || confirmDocumentWidgetRequest === undefined) {
                throw new base_1.RequiredError('confirmDocumentWidgetRequest', 'Required parameter confirmDocumentWidgetRequest was null or undefined when calling confirmDocumentWidget.');
            }
            const localVarPath = `/documents/{documentId}/widget/confirm`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof confirmDocumentWidgetRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(confirmDocumentWidgetRequest !== undefined ? confirmDocumentWidgetRequest : {})
                : (confirmDocumentWidgetRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} documentId Document ID
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmUploadImageRequest} [confirmUploadImageRequest] Confirm data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmReliningImageUpload: async (documentId, templateId, confirmUploadImageRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling confirmReliningImageUpload.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling confirmReliningImageUpload.');
            }
            const localVarPath = `/documents/confirm-relining-image-upload/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof confirmUploadImageRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(confirmUploadImageRequest !== undefined ? confirmUploadImageRequest : {})
                : (confirmUploadImageRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Confirm a User
         * @param {ConfirmUserRequest} confirmUserRequest User to be Confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUser: async (confirmUserRequest, options = {}) => {
            // verify required parameter 'confirmUserRequest' is not null or undefined
            if (confirmUserRequest === null || confirmUserRequest === undefined) {
                throw new base_1.RequiredError('confirmUserRequest', 'Required parameter confirmUserRequest was null or undefined when calling confirmUser.');
            }
            const localVarPath = `/users/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof confirmUserRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(confirmUserRequest !== undefined ? confirmUserRequest : {})
                : (confirmUserRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Project
         * @param {string} id
         * @param {CreateClientProjectRequest} createClientProjectRequest Project to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientProject: async (id, createClientProjectRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling createClientProject.');
            }
            // verify required parameter 'createClientProjectRequest' is not null or undefined
            if (createClientProjectRequest === null || createClientProjectRequest === undefined) {
                throw new base_1.RequiredError('createClientProjectRequest', 'Required parameter createClientProjectRequest was null or undefined when calling createClientProject.');
            }
            const localVarPath = `/clients/{id}/projects`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createClientProjectRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createClientProjectRequest !== undefined ? createClientProjectRequest : {})
                : (createClientProjectRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a Delivery
         * @param {CreateDeliveryRequest} createDeliveryRequest Delivery Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDelivery: async (createDeliveryRequest, options = {}) => {
            // verify required parameter 'createDeliveryRequest' is not null or undefined
            if (createDeliveryRequest === null || createDeliveryRequest === undefined) {
                throw new base_1.RequiredError('createDeliveryRequest', 'Required parameter createDeliveryRequest was null or undefined when calling createDelivery.');
            }
            const localVarPath = `/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createDeliveryRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createDeliveryRequest !== undefined ? createDeliveryRequest : {})
                : (createDeliveryRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling createDocument.');
            }
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create an Item
         * @param {CreateItemRequest} createItemRequest Item Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem: async (createItemRequest, options = {}) => {
            // verify required parameter 'createItemRequest' is not null or undefined
            if (createItemRequest === null || createItemRequest === undefined) {
                throw new base_1.RequiredError('createItemRequest', 'Required parameter createItemRequest was null or undefined when calling createItem.');
            }
            const localVarPath = `/items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createItemRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createItemRequest !== undefined ? createItemRequest : {})
                : (createItemRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create an Order
         * @param {CreateOrderRequest} createOrderRequest Order Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (createOrderRequest, options = {}) => {
            // verify required parameter 'createOrderRequest' is not null or undefined
            if (createOrderRequest === null || createOrderRequest === undefined) {
                throw new base_1.RequiredError('createOrderRequest', 'Required parameter createOrderRequest was null or undefined when calling createOrder.');
            }
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createOrderRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createOrderRequest !== undefined ? createOrderRequest : {})
                : (createOrderRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a stripe free subscription
         * @param {CreatePaymentsFreeSubscriptionRequest} createPaymentsFreeSubscriptionRequest Create payments free subscription request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentsFreeSubscription: async (createPaymentsFreeSubscriptionRequest, options = {}) => {
            // verify required parameter 'createPaymentsFreeSubscriptionRequest' is not null or undefined
            if (createPaymentsFreeSubscriptionRequest === null || createPaymentsFreeSubscriptionRequest === undefined) {
                throw new base_1.RequiredError('createPaymentsFreeSubscriptionRequest', 'Required parameter createPaymentsFreeSubscriptionRequest was null or undefined when calling createPaymentsFreeSubscription.');
            }
            const localVarPath = `/payments/create-free-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createPaymentsFreeSubscriptionRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createPaymentsFreeSubscriptionRequest !== undefined ? createPaymentsFreeSubscriptionRequest : {})
                : (createPaymentsFreeSubscriptionRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a stripe subscription
         * @param {CreatePaymentsSubscriptionRequest} createPaymentsSubscriptionRequest Create payments subscription request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentsSubscription: async (createPaymentsSubscriptionRequest, options = {}) => {
            // verify required parameter 'createPaymentsSubscriptionRequest' is not null or undefined
            if (createPaymentsSubscriptionRequest === null || createPaymentsSubscriptionRequest === undefined) {
                throw new base_1.RequiredError('createPaymentsSubscriptionRequest', 'Required parameter createPaymentsSubscriptionRequest was null or undefined when calling createPaymentsSubscription.');
            }
            const localVarPath = `/payments/create-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createPaymentsSubscriptionRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createPaymentsSubscriptionRequest !== undefined ? createPaymentsSubscriptionRequest : {})
                : (createPaymentsSubscriptionRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a Warehouse
         * @param {CreateWarehouseRequest} createWarehouseRequest Warehouse Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWarehouse: async (createWarehouseRequest, options = {}) => {
            // verify required parameter 'createWarehouseRequest' is not null or undefined
            if (createWarehouseRequest === null || createWarehouseRequest === undefined) {
                throw new base_1.RequiredError('createWarehouseRequest', 'Required parameter createWarehouseRequest was null or undefined when calling createWarehouse.');
            }
            const localVarPath = `/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createWarehouseRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createWarehouseRequest !== undefined ? createWarehouseRequest : {})
                : (createWarehouseRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a Workspace
         * @param {CreateWorkspaceRequest} createWorkspaceRequest Workspace Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspace: async (createWorkspaceRequest, options = {}) => {
            // verify required parameter 'createWorkspaceRequest' is not null or undefined
            if (createWorkspaceRequest === null || createWorkspaceRequest === undefined) {
                throw new base_1.RequiredError('createWorkspaceRequest', 'Required parameter createWorkspaceRequest was null or undefined when calling createWorkspace.');
            }
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createWorkspaceRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createWorkspaceRequest !== undefined ? createWorkspaceRequest : {})
                : (createWorkspaceRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create Workspace Clients
         * @param {CreateWorkspaceClientRequest} createWorkspaceClientRequest Workspace Client Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceClient: async (createWorkspaceClientRequest, options = {}) => {
            // verify required parameter 'createWorkspaceClientRequest' is not null or undefined
            if (createWorkspaceClientRequest === null || createWorkspaceClientRequest === undefined) {
                throw new base_1.RequiredError('createWorkspaceClientRequest', 'Required parameter createWorkspaceClientRequest was null or undefined when calling createWorkspaceClient.');
            }
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof createWorkspaceClientRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(createWorkspaceClientRequest !== undefined ? createWorkspaceClientRequest : {})
                : (createWorkspaceClientRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDelivery: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteDelivery.');
            }
            const localVarPath = `/deliveries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (documentId, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling deleteDocument.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling deleteDocument.');
            }
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a Widget from a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {string} widgetKey The Widget key to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentWidget: async (documentId, templateId, widgetKey, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling deleteDocumentWidget.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling deleteDocumentWidget.');
            }
            // verify required parameter 'widgetKey' is not null or undefined
            if (widgetKey === null || widgetKey === undefined) {
                throw new base_1.RequiredError('widgetKey', 'Required parameter widgetKey was null or undefined when calling deleteDocumentWidget.');
            }
            const localVarPath = `/documents/{documentId}/widget`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            if (widgetKey !== undefined) {
                localVarQueryParameter['widgetKey'] = widgetKey;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an invited User
         * @param {DeleteInviteUserRequest} deleteInviteUserRequest The invited User to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitedUser: async (deleteInviteUserRequest, options = {}) => {
            // verify required parameter 'deleteInviteUserRequest' is not null or undefined
            if (deleteInviteUserRequest === null || deleteInviteUserRequest === undefined) {
                throw new base_1.RequiredError('deleteInviteUserRequest', 'Required parameter deleteInviteUserRequest was null or undefined when calling deleteInvitedUser.');
            }
            const localVarPath = `/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof deleteInviteUserRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(deleteInviteUserRequest !== undefined ? deleteInviteUserRequest : {})
                : (deleteInviteUserRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteOrder.');
            }
            const localVarPath = `/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Finalize a Delivery
         * @param {string} id
         * @param {FinalizeDeliveryRequest} finalizeDeliveryRequest Delivery Object to be Finalized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeDelivery: async (id, finalizeDeliveryRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling finalizeDelivery.');
            }
            // verify required parameter 'finalizeDeliveryRequest' is not null or undefined
            if (finalizeDeliveryRequest === null || finalizeDeliveryRequest === undefined) {
                throw new base_1.RequiredError('finalizeDeliveryRequest', 'Required parameter finalizeDeliveryRequest was null or undefined when calling finalizeDelivery.');
            }
            const localVarPath = `/deliveries/{id}/finalize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof finalizeDeliveryRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(finalizeDeliveryRequest !== undefined ? finalizeDeliveryRequest : {})
                : (finalizeDeliveryRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Finalize a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {FinalizeDocumentRequest} finalizeDocumentRequest Finalize Document Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeDocument: async (documentId, templateId, finalizeDocumentRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling finalizeDocument.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling finalizeDocument.');
            }
            // verify required parameter 'finalizeDocumentRequest' is not null or undefined
            if (finalizeDocumentRequest === null || finalizeDocumentRequest === undefined) {
                throw new base_1.RequiredError('finalizeDocumentRequest', 'Required parameter finalizeDocumentRequest was null or undefined when calling finalizeDocument.');
            }
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof finalizeDocumentRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(finalizeDocumentRequest !== undefined ? finalizeDocumentRequest : {})
                : (finalizeDocumentRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Finalize an Order
         * @param {string} id
         * @param {FinalizeOrderRequest} finalizeOrderRequest Order to be finalized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeOrder: async (id, finalizeOrderRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling finalizeOrder.');
            }
            // verify required parameter 'finalizeOrderRequest' is not null or undefined
            if (finalizeOrderRequest === null || finalizeOrderRequest === undefined) {
                throw new base_1.RequiredError('finalizeOrderRequest', 'Required parameter finalizeOrderRequest was null or undefined when calling finalizeOrder.');
            }
            const localVarPath = `/orders/{id}/finalize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof finalizeOrderRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(finalizeOrderRequest !== undefined ? finalizeOrderRequest : {})
                : (finalizeOrderRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current active (default) payment method for the workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePaymentMethod: async (options = {}) => {
            const localVarPath = `/payments/active-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Deliveries
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeliveries: async (limit, skip, options = {}) => {
            const localVarPath = `/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Documents
         * @param {number} [limit] Limits the number of elements returned
         * @param {string} [query] Text field result
         * @param {number} [skip] Skips a number of elements
         * @param {'true' | 'false'} [userOnly] Boolean to return user only Documents
         * @param {string | Array<string>} [statuses] Status of the documents to return
         * @param {'id' | 'status' | 'dateCreated' | 'dateUpdated' | 'dateFinished'} [sortBy]
         * @param {'ASC' | 'DESC'} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocuments: async (limit, query, skip, userOnly, statuses, sortBy, order, options = {}) => {
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (userOnly !== undefined) {
                localVarQueryParameter['userOnly'] = userOnly;
            }
            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get All External Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExternalUsers: async (options = {}) => {
            const localVarPath = `/external-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Items
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItems: async (limit, skip, options = {}) => {
            const localVarPath = `/items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Notifications
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications: async (limit, skip, options = {}) => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Orders
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders: async (limit, skip, options = {}) => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplates: async (options = {}) => {
            const localVarPath = `/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (options = {}) => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all users with permissions for a particular template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersWithPermission: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getAllUsersWithPermission.');
            }
            const localVarPath = `/users/permissions/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all the users without permission for a particular template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersWithoutPermission: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getAllUsersWithoutPermission.');
            }
            const localVarPath = `/users/no-permissions/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Warehouses
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWarehouses: async (limit, skip, options = {}) => {
            const localVarPath = `/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the billing history for the current workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingHistory: async (options = {}) => {
            const localVarPath = `/payments/billing-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get client projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientProjects: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getClientProjects.');
            }
            const localVarPath = `/clients/{id}/projects`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelivery: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getDelivery.');
            }
            const localVarPath = `/deliveries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Delivery Document
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getDeliveryDocument.');
            }
            const localVarPath = `/deliveries/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (documentId, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling getDocument.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getDocument.');
            }
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Document Certificate
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentCertificate: async (documentId, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling getDocumentCertificate.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getDocumentCertificate.');
            }
            const localVarPath = `/documents/{documentId}/certificate`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentImage: async (documentId, imageName, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling getDocumentImage.');
            }
            // verify required parameter 'imageName' is not null or undefined
            if (imageName === null || imageName === undefined) {
                throw new base_1.RequiredError('imageName', 'Required parameter imageName was null or undefined when calling getDocumentImage.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getDocumentImage.');
            }
            const localVarPath = `/documents/{documentId}/image/{imageName}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"imageName"}}`, encodeURIComponent(String(imageName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all recipients of a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentRecipients: async (documentId, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling getDocumentRecipients.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getDocumentRecipients.');
            }
            const localVarPath = `/documents/{documentId}/recipients`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Logged In User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoggedInUser: async (options = {}) => {
            const localVarPath = `/users/logged-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get module prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulePrices: async (options = {}) => {
            const localVarPath = `/payments/module-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getOrder.');
            }
            const localVarPath = `/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Order Document
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDocument: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getOrderDocument.');
            }
            const localVarPath = `/orders/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get payment discount percentages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDiscounts: async (options = {}) => {
            const localVarPath = `/payments/discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin get all projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: async (options = {}) => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} documentId Document ID
         * @param {string} templateId Template ID
         * @param {string} imageName The name of the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReliningUploadImageUrl: async (documentId, templateId, imageName, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling getReliningUploadImageUrl.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getReliningUploadImageUrl.');
            }
            // verify required parameter 'imageName' is not null or undefined
            if (imageName === null || imageName === undefined) {
                throw new base_1.RequiredError('imageName', 'Required parameter imageName was null or undefined when calling getReliningUploadImageUrl.');
            }
            const localVarPath = `/documents/get-relining-upload-image-url/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            if (imageName !== undefined) {
                localVarQueryParameter['imageName'] = imageName;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all running documents for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningDocumentsForUser: async (options = {}) => {
            const localVarPath = `/documents/running-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get information about the subscription of a workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: async (options = {}) => {
            const localVarPath = `/payments/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the upcoming invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice: async (options = {}) => {
            const localVarPath = `/payments/get-upcoming-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get number of users for each template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersTemplates: async (options = {}) => {
            const localVarPath = `/templates/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Warehouse
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getWarehouseById.');
            }
            const localVarPath = `/warehouses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Warehouse Inventory
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseInventory: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getWarehouseInventory.');
            }
            const localVarPath = `/warehouses/{id}/inventory`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Widget Upload Url
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {GetWidgetUploadUrlRequest} getWidgetUploadUrlRequest Get Widget Upload Url Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetUploadUrl: async (documentId, templateId, getWidgetUploadUrlRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling getWidgetUploadUrl.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getWidgetUploadUrl.');
            }
            // verify required parameter 'getWidgetUploadUrlRequest' is not null or undefined
            if (getWidgetUploadUrlRequest === null || getWidgetUploadUrlRequest === undefined) {
                throw new base_1.RequiredError('getWidgetUploadUrlRequest', 'Required parameter getWidgetUploadUrlRequest was null or undefined when calling getWidgetUploadUrl.');
            }
            const localVarPath = `/documents/{documentId}/widget`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof getWidgetUploadUrlRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(getWidgetUploadUrlRequest !== undefined ? getWidgetUploadUrlRequest : {})
                : (getWidgetUploadUrlRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspace: async (options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all Workspace Clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceClients: async (options = {}) => {
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should gain permissions to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTemplatePermission: async (modifyPermissionRequest, options = {}) => {
            const localVarPath = `/template-permissions/grant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof modifyPermissionRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(modifyPermissionRequest !== undefined ? modifyPermissionRequest : {})
                : (modifyPermissionRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Invite a User
         * @param {InviteUsersRequest} inviteUsersRequest User to be Invited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (inviteUsersRequest, options = {}) => {
            // verify required parameter 'inviteUsersRequest' is not null or undefined
            if (inviteUsersRequest === null || inviteUsersRequest === undefined) {
                throw new base_1.RequiredError('inviteUsersRequest', 'Required parameter inviteUsersRequest was null or undefined when calling inviteUser.');
            }
            const localVarPath = `/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof inviteUsersRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(inviteUsersRequest !== undefined ? inviteUsersRequest : {})
                : (inviteUsersRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {NotificationsMarkSeenRequest} [notificationsMarkSeenRequest] The IDs of the notifications which should be marked as seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsUserMarkSeen: async (userId, notificationsMarkSeenRequest, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling notificationsUserMarkSeen.');
            }
            const localVarPath = `/notifications/user/{userId}/mark-seen`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof notificationsMarkSeenRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(notificationsMarkSeenRequest !== undefined ? notificationsMarkSeenRequest : {})
                : (notificationsMarkSeenRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reactivate the subscription for the workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription: async (options = {}) => {
            const localVarPath = `/payments/subscription/reactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reject a Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDelivery: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling rejectDelivery.');
            }
            const localVarPath = `/deliveries/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reject an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling rejectOrder.');
            }
            const localVarPath = `/orders/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliningTimerReset: async (documentId, templateId, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling reliningTimerReset.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling reliningTimerReset.');
            }
            const localVarPath = `/documents/relining/timer/reset/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ReliningTimerStartRequest} [reliningTimerStartRequest] Timestamp of when the user clicked the timer start button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliningTimerStart: async (documentId, templateId, reliningTimerStartRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling reliningTimerStart.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling reliningTimerStart.');
            }
            const localVarPath = `/documents/relining/timer/start/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof reliningTimerStartRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(reliningTimerStartRequest !== undefined ? reliningTimerStartRequest : {})
                : (reliningTimerStartRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ReliningTimerStopRequest} [reliningTimerStopRequest] Timestamp of when the user clicked the timer stop button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliningTimerStop: async (documentId, templateId, reliningTimerStopRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling reliningTimerStop.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling reliningTimerStop.');
            }
            const localVarPath = `/documents/relining/timer/stop/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof reliningTimerStopRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(reliningTimerStopRequest !== undefined ? reliningTimerStopRequest : {})
                : (reliningTimerStopRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove external users from a workspace
         * @param {RemoveExternalUsersRequest} [removeExternalUsersRequest] The emails of the users that should be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExternalUsers: async (removeExternalUsersRequest, options = {}) => {
            const localVarPath = `/external-users/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof removeExternalUsersRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(removeExternalUsersRequest !== undefined ? removeExternalUsersRequest : {})
                : (removeExternalUsersRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {RemoveReliningImageRequest} [removeReliningImageRequest] Timestamp of when the user attempted to delete the image, the image name along with the object path to the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeReliningImage: async (documentId, templateId, removeReliningImageRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling removeReliningImage.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling removeReliningImage.');
            }
            const localVarPath = `/documents/relining/image/remove/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof removeReliningImageRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(removeReliningImageRequest !== undefined ? removeReliningImageRequest : {})
                : (removeReliningImageRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Resend Invite to the User
         * @param {ResendInviteUserRequest} resendInviteUserRequest Resend Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvite: async (resendInviteUserRequest, options = {}) => {
            // verify required parameter 'resendInviteUserRequest' is not null or undefined
            if (resendInviteUserRequest === null || resendInviteUserRequest === undefined) {
                throw new base_1.RequiredError('resendInviteUserRequest', 'Required parameter resendInviteUserRequest was null or undefined when calling resendInvite.');
            }
            const localVarPath = `/users/invite/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof resendInviteUserRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(resendInviteUserRequest !== undefined ? resendInviteUserRequest : {})
                : (resendInviteUserRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should lose permissions to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTemplatePermission: async (modifyPermissionRequest, options = {}) => {
            const localVarPath = `/template-permissions/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof modifyPermissionRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(modifyPermissionRequest !== undefined ? modifyPermissionRequest : {})
                : (modifyPermissionRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a customer\'s payment method.
         * @param {UpdateCustomerPaymentMethod} updateCustomerPaymentMethod The payment method ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerPaymentMethod: async (updateCustomerPaymentMethod, options = {}) => {
            // verify required parameter 'updateCustomerPaymentMethod' is not null or undefined
            if (updateCustomerPaymentMethod === null || updateCustomerPaymentMethod === undefined) {
                throw new base_1.RequiredError('updateCustomerPaymentMethod', 'Required parameter updateCustomerPaymentMethod was null or undefined when calling updateCustomerPaymentMethod.');
            }
            const localVarPath = `/payments/update-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateCustomerPaymentMethod !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateCustomerPaymentMethod !== undefined ? updateCustomerPaymentMethod : {})
                : (updateCustomerPaymentMethod || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a Delivery
         * @param {string} id
         * @param {UpdateDeliveryRequest} updateDeliveryRequest Delivery Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelivery: async (id, updateDeliveryRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateDelivery.');
            }
            // verify required parameter 'updateDeliveryRequest' is not null or undefined
            if (updateDeliveryRequest === null || updateDeliveryRequest === undefined) {
                throw new base_1.RequiredError('updateDeliveryRequest', 'Required parameter updateDeliveryRequest was null or undefined when calling updateDelivery.');
            }
            const localVarPath = `/deliveries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateDeliveryRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateDeliveryRequest !== undefined ? updateDeliveryRequest : {})
                : (updateDeliveryRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {UpdateDocumentRequest} updateDocumentRequest Updated Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: async (documentId, templateId, updateDocumentRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling updateDocument.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling updateDocument.');
            }
            // verify required parameter 'updateDocumentRequest' is not null or undefined
            if (updateDocumentRequest === null || updateDocumentRequest === undefined) {
                throw new base_1.RequiredError('updateDocumentRequest', 'Required parameter updateDocumentRequest was null or undefined when calling updateDocument.');
            }
            const localVarPath = `/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateDocumentRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateDocumentRequest !== undefined ? updateDocumentRequest : {})
                : (updateDocumentRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a Document Assignee
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {UpdateDocumentAssigneeRequest} updateDocumentAssigneeRequest Updated Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentAssignee: async (documentId, templateId, updateDocumentAssigneeRequest, options = {}) => {
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new base_1.RequiredError('documentId', 'Required parameter documentId was null or undefined when calling updateDocumentAssignee.');
            }
            // verify required parameter 'templateId' is not null or undefined
            if (templateId === null || templateId === undefined) {
                throw new base_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling updateDocumentAssignee.');
            }
            // verify required parameter 'updateDocumentAssigneeRequest' is not null or undefined
            if (updateDocumentAssigneeRequest === null || updateDocumentAssigneeRequest === undefined) {
                throw new base_1.RequiredError('updateDocumentAssigneeRequest', 'Required parameter updateDocumentAssigneeRequest was null or undefined when calling updateDocumentAssignee.');
            }
            const localVarPath = `/documents/{documentId}/assignee`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateDocumentAssigneeRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateDocumentAssigneeRequest !== undefined ? updateDocumentAssigneeRequest : {})
                : (updateDocumentAssigneeRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Item
         * @param {string} id
         * @param {UpdateItemRequest} updateItemRequest Item Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItem: async (id, updateItemRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateItem.');
            }
            // verify required parameter 'updateItemRequest' is not null or undefined
            if (updateItemRequest === null || updateItemRequest === undefined) {
                throw new base_1.RequiredError('updateItemRequest', 'Required parameter updateItemRequest was null or undefined when calling updateItem.');
            }
            const localVarPath = `/items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateItemRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateItemRequest !== undefined ? updateItemRequest : {})
                : (updateItemRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Item Image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemImage: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateItemImage.');
            }
            const localVarPath = `/items/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Logged In User
         * @param {UpdateUserRequest} updateUserRequest Update Logged In User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoggedInUser: async (updateUserRequest, options = {}) => {
            // verify required parameter 'updateUserRequest' is not null or undefined
            if (updateUserRequest === null || updateUserRequest === undefined) {
                throw new base_1.RequiredError('updateUserRequest', 'Required parameter updateUserRequest was null or undefined when calling updateLoggedInUser.');
            }
            const localVarPath = `/users/logged-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateUserRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateUserRequest !== undefined ? updateUserRequest : {})
                : (updateUserRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an Order
         * @param {string} id
         * @param {UpdateOrderRequest} updateOrderRequest Order Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: async (id, updateOrderRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateOrder.');
            }
            // verify required parameter 'updateOrderRequest' is not null or undefined
            if (updateOrderRequest === null || updateOrderRequest === undefined) {
                throw new base_1.RequiredError('updateOrderRequest', 'Required parameter updateOrderRequest was null or undefined when calling updateOrder.');
            }
            const localVarPath = `/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateOrderRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateOrderRequest !== undefined ? updateOrderRequest : {})
                : (updateOrderRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a setup intent with a new payment method
         * @param {UpdateSetupIntentRequest} updateSetupIntentRequest Provide the setup intent and payment method IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSetupIntent: async (updateSetupIntentRequest, options = {}) => {
            // verify required parameter 'updateSetupIntentRequest' is not null or undefined
            if (updateSetupIntentRequest === null || updateSetupIntentRequest === undefined) {
                throw new base_1.RequiredError('updateSetupIntentRequest', 'Required parameter updateSetupIntentRequest was null or undefined when calling updateSetupIntent.');
            }
            const localVarPath = `/payments/update-setup-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateSetupIntentRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateSetupIntentRequest !== undefined ? updateSetupIntentRequest : {})
                : (updateSetupIntentRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the profile picture of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfileImage: async (options = {}) => {
            const localVarPath = `/users/profile-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a User Status
         * @param {string} userId
         * @param {UpdateUserStatusRequest} updateUserStatusRequest Update User Status Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus: async (userId, updateUserStatusRequest, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserStatus.');
            }
            // verify required parameter 'updateUserStatusRequest' is not null or undefined
            if (updateUserStatusRequest === null || updateUserStatusRequest === undefined) {
                throw new base_1.RequiredError('updateUserStatusRequest', 'Required parameter updateUserStatusRequest was null or undefined when calling updateUserStatus.');
            }
            const localVarPath = `/users/{userId}/status`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateUserStatusRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateUserStatusRequest !== undefined ? updateUserStatusRequest : {})
                : (updateUserStatusRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Warehouse Image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWarehouseImage: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateWarehouseImage.');
            }
            const localVarPath = `/warehouses/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a warehouses
         * @param {string} id
         * @param {UpdateWarehouseRequest} [updateWarehouseRequest] Update warehouse object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWarehouses: async (id, updateWarehouseRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateWarehouses.');
            }
            const localVarPath = `/warehouses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateWarehouseRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateWarehouseRequest !== undefined ? updateWarehouseRequest : {})
                : (updateWarehouseRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a workspace
         * @param {UpdateWorkspaceRequest} [updateWorkspaceRequest] Update workspace object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspace: async (updateWorkspaceRequest, options = {}) => {
            const localVarPath = `/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateWorkspaceRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateWorkspaceRequest !== undefined ? updateWorkspaceRequest : {})
                : (updateWorkspaceRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Workspace Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceImage: async (options = {}) => {
            const localVarPath = `/workspaces/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Workspace User
         * @param {string} userId
         * @param {UpdateUserWorkspaceRequest} updateUserWorkspaceRequest Update Workspace User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceUser: async (userId, updateUserWorkspaceRequest, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateWorkspaceUser.');
            }
            // verify required parameter 'updateUserWorkspaceRequest' is not null or undefined
            if (updateUserWorkspaceRequest === null || updateUserWorkspaceRequest === undefined) {
                throw new base_1.RequiredError('updateUserWorkspaceRequest', 'Required parameter updateUserWorkspaceRequest was null or undefined when calling updateWorkspaceUser.');
            }
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-ACCESS-TOKEN")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-ACCESS-TOKEN"] = localVarApiKeyValue;
            }
            // authentication BearerAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const nonString = typeof updateUserWorkspaceRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(updateUserWorkspaceRequest !== undefined ? updateUserWorkspaceRequest : {})
                : (updateUserWorkspaceRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TraceApiAxiosParamCreator = TraceApiAxiosParamCreator;
/**
 * TraceApi - functional programming interface
 * @export
 */
const TraceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Add Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDocumentImage(documentId, imageName, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).addDocumentImage(documentId, imageName, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Add a Widget to a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {DocumentWidgetEnum} widget The Widget to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDocumentWidget(documentId, templateId, widget, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).addDocumentWidget(documentId, templateId, widget, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Admin Add Workspace Trace Provider
         * @param {string} workspaceId ID of the Workspace
         * @param {AdminAddTraceProviderRequest} adminAddTraceProviderRequest Trace Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAddWorkspaceTraceProvider(workspaceId, adminAddTraceProviderRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).adminAddWorkspaceTraceProvider(workspaceId, adminAddTraceProviderRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary AdminGet All Workspaces
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetAllWorkspaces(limit, skip, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).adminGetAllWorkspaces(limit, skip, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Admin Get Workspace
         * @param {string} workspaceId ID of the Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetWorkspace(workspaceId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).adminGetWorkspace(workspaceId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Admin Update Workspace
         * @param {string} workspaceId ID of the Workspace
         * @param {AdminUpdateWorkspaceRequest} adminUpdateWorkspaceRequest Updated Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateWorkspace(workspaceId, adminUpdateWorkspaceRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).adminUpdateWorkspace(workspaceId, adminUpdateWorkspaceRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Approve an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOrder(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).approveOrder(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Cancel the subscription for the workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).cancelSubscription(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Clear a widget\'s data
         * @param {string} documentId Id of the document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ClearDocumentWidgetRequest} [clearDocumentWidgetRequest] An object containing the widget key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearDocumentWidget(documentId, templateId, clearDocumentWidgetRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).clearDocumentWidget(documentId, templateId, clearDocumentWidgetRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Confirm Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmDocumentImageRequest} confirmDocumentImageRequest Confirm Document Image Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDocumentImage(documentId, imageName, templateId, confirmDocumentImageRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).confirmDocumentImage(documentId, imageName, templateId, confirmDocumentImageRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Confirm a Widget on a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmDocumentWidgetRequest} confirmDocumentWidgetRequest Confirm Widget Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDocumentWidget(documentId, templateId, confirmDocumentWidgetRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).confirmDocumentWidget(documentId, templateId, confirmDocumentWidgetRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} documentId Document ID
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmUploadImageRequest} [confirmUploadImageRequest] Confirm data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmReliningImageUpload(documentId, templateId, confirmUploadImageRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).confirmReliningImageUpload(documentId, templateId, confirmUploadImageRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Confirm a User
         * @param {ConfirmUserRequest} confirmUserRequest User to be Confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmUser(confirmUserRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).confirmUser(confirmUserRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create Project
         * @param {string} id
         * @param {CreateClientProjectRequest} createClientProjectRequest Project to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClientProject(id, createClientProjectRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createClientProject(id, createClientProjectRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a Delivery
         * @param {CreateDeliveryRequest} createDeliveryRequest Delivery Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDelivery(createDeliveryRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createDelivery(createDeliveryRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocument(templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createDocument(templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create an Item
         * @param {CreateItemRequest} createItemRequest Item Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createItem(createItemRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createItem(createItemRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create an Order
         * @param {CreateOrderRequest} createOrderRequest Order Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(createOrderRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createOrder(createOrderRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a stripe free subscription
         * @param {CreatePaymentsFreeSubscriptionRequest} createPaymentsFreeSubscriptionRequest Create payments free subscription request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentsFreeSubscription(createPaymentsFreeSubscriptionRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createPaymentsFreeSubscription(createPaymentsFreeSubscriptionRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a stripe subscription
         * @param {CreatePaymentsSubscriptionRequest} createPaymentsSubscriptionRequest Create payments subscription request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentsSubscription(createPaymentsSubscriptionRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createPaymentsSubscription(createPaymentsSubscriptionRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a Warehouse
         * @param {CreateWarehouseRequest} createWarehouseRequest Warehouse Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWarehouse(createWarehouseRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createWarehouse(createWarehouseRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create a Workspace
         * @param {CreateWorkspaceRequest} createWorkspaceRequest Workspace Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspace(createWorkspaceRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createWorkspace(createWorkspaceRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Create Workspace Clients
         * @param {CreateWorkspaceClientRequest} createWorkspaceClientRequest Workspace Client Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspaceClient(createWorkspaceClientRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).createWorkspaceClient(createWorkspaceClientRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDelivery(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).deleteDelivery(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(documentId, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).deleteDocument(documentId, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete a Widget from a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {string} widgetKey The Widget key to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentWidget(documentId, templateId, widgetKey, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).deleteDocumentWidget(documentId, templateId, widgetKey, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete an invited User
         * @param {DeleteInviteUserRequest} deleteInviteUserRequest The invited User to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvitedUser(deleteInviteUserRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).deleteInvitedUser(deleteInviteUserRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Delete an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrder(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).deleteOrder(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Finalize a Delivery
         * @param {string} id
         * @param {FinalizeDeliveryRequest} finalizeDeliveryRequest Delivery Object to be Finalized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeDelivery(id, finalizeDeliveryRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).finalizeDelivery(id, finalizeDeliveryRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Finalize a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {FinalizeDocumentRequest} finalizeDocumentRequest Finalize Document Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeDocument(documentId, templateId, finalizeDocumentRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).finalizeDocument(documentId, templateId, finalizeDocumentRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Finalize an Order
         * @param {string} id
         * @param {FinalizeOrderRequest} finalizeOrderRequest Order to be finalized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeOrder(id, finalizeOrderRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).finalizeOrder(id, finalizeOrderRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the current active (default) payment method for the workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivePaymentMethod(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getActivePaymentMethod(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Deliveries
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDeliveries(limit, skip, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllDeliveries(limit, skip, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Documents
         * @param {number} [limit] Limits the number of elements returned
         * @param {string} [query] Text field result
         * @param {number} [skip] Skips a number of elements
         * @param {'true' | 'false'} [userOnly] Boolean to return user only Documents
         * @param {string | Array<string>} [statuses] Status of the documents to return
         * @param {'id' | 'status' | 'dateCreated' | 'dateUpdated' | 'dateFinished'} [sortBy]
         * @param {'ASC' | 'DESC'} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDocuments(limit, query, skip, userOnly, statuses, sortBy, order, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllDocuments(limit, query, skip, userOnly, statuses, sortBy, order, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get All External Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllExternalUsers(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllExternalUsers(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Items
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllItems(limit, skip, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllItems(limit, skip, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Notifications
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotifications(limit, skip, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllNotifications(limit, skip, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Orders
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrders(limit, skip, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllOrders(limit, skip, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTemplates(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllTemplates(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllUsers(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all users with permissions for a particular template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersWithPermission(templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllUsersWithPermission(templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all the users without permission for a particular template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersWithoutPermission(templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllUsersWithoutPermission(templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Warehouses
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWarehouses(limit, skip, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getAllWarehouses(limit, skip, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the billing history for the current workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillingHistory(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getBillingHistory(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get client projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientProjects(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getClientProjects(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelivery(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getDelivery(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Delivery Document
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryDocument(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getDeliveryDocument(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(documentId, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getDocument(documentId, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Document Certificate
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentCertificate(documentId, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getDocumentCertificate(documentId, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentImage(documentId, imageName, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getDocumentImage(documentId, imageName, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all recipients of a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentRecipients(documentId, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getDocumentRecipients(documentId, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Logged In User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoggedInUser(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getLoggedInUser(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get module prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModulePrices(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getModulePrices(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getOrder(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Order Document
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDocument(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getOrderDocument(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get payment discount percentages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentDiscounts(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getPaymentDiscounts(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Admin get all projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjects(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getProjects(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} documentId Document ID
         * @param {string} templateId Template ID
         * @param {string} imageName The name of the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReliningUploadImageUrl(documentId, templateId, imageName, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getReliningUploadImageUrl(documentId, templateId, imageName, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all running documents for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunningDocumentsForUser(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getRunningDocumentsForUser(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get information about the subscription of a workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscription(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getSubscription(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the upcoming invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpcomingInvoice(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getUpcomingInvoice(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get number of users for each template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersTemplates(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getUsersTemplates(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a Warehouse
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehouseById(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getWarehouseById(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get Warehouse Inventory
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehouseInventory(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getWarehouseInventory(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a Widget Upload Url
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {GetWidgetUploadUrlRequest} getWidgetUploadUrlRequest Get Widget Upload Url Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetUploadUrl(documentId, templateId, getWidgetUploadUrlRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getWidgetUploadUrl(documentId, templateId, getWidgetUploadUrlRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspace(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getWorkspace(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all Workspace Clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceClients(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).getWorkspaceClients(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should gain permissions to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantTemplatePermission(modifyPermissionRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).grantTemplatePermission(modifyPermissionRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Invite a User
         * @param {InviteUsersRequest} inviteUsersRequest User to be Invited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(inviteUsersRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).inviteUser(inviteUsersRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} userId
         * @param {NotificationsMarkSeenRequest} [notificationsMarkSeenRequest] The IDs of the notifications which should be marked as seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsUserMarkSeen(userId, notificationsMarkSeenRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).notificationsUserMarkSeen(userId, notificationsMarkSeenRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Reactivate the subscription for the workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateSubscription(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).reactivateSubscription(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Reject a Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectDelivery(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).rejectDelivery(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Reject an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectOrder(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).rejectOrder(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reliningTimerReset(documentId, templateId, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).reliningTimerReset(documentId, templateId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ReliningTimerStartRequest} [reliningTimerStartRequest] Timestamp of when the user clicked the timer start button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reliningTimerStart(documentId, templateId, reliningTimerStartRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).reliningTimerStart(documentId, templateId, reliningTimerStartRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ReliningTimerStopRequest} [reliningTimerStopRequest] Timestamp of when the user clicked the timer stop button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reliningTimerStop(documentId, templateId, reliningTimerStopRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).reliningTimerStop(documentId, templateId, reliningTimerStopRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Remove external users from a workspace
         * @param {RemoveExternalUsersRequest} [removeExternalUsersRequest] The emails of the users that should be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeExternalUsers(removeExternalUsersRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).removeExternalUsers(removeExternalUsersRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {RemoveReliningImageRequest} [removeReliningImageRequest] Timestamp of when the user attempted to delete the image, the image name along with the object path to the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeReliningImage(documentId, templateId, removeReliningImageRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).removeReliningImage(documentId, templateId, removeReliningImageRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Resend Invite to the User
         * @param {ResendInviteUserRequest} resendInviteUserRequest Resend Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvite(resendInviteUserRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).resendInvite(resendInviteUserRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should lose permissions to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeTemplatePermission(modifyPermissionRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).revokeTemplatePermission(modifyPermissionRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a customer\'s payment method.
         * @param {UpdateCustomerPaymentMethod} updateCustomerPaymentMethod The payment method ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerPaymentMethod(updateCustomerPaymentMethod, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateCustomerPaymentMethod(updateCustomerPaymentMethod, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a Delivery
         * @param {string} id
         * @param {UpdateDeliveryRequest} updateDeliveryRequest Delivery Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDelivery(id, updateDeliveryRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateDelivery(id, updateDeliveryRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {UpdateDocumentRequest} updateDocumentRequest Updated Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocument(documentId, templateId, updateDocumentRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateDocument(documentId, templateId, updateDocumentRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a Document Assignee
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {UpdateDocumentAssigneeRequest} updateDocumentAssigneeRequest Updated Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentAssignee(documentId, templateId, updateDocumentAssigneeRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateDocumentAssignee(documentId, templateId, updateDocumentAssigneeRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update Item
         * @param {string} id
         * @param {UpdateItemRequest} updateItemRequest Item Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItem(id, updateItemRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateItem(id, updateItemRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update Item Image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItemImage(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateItemImage(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update Logged In User
         * @param {UpdateUserRequest} updateUserRequest Update Logged In User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoggedInUser(updateUserRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateLoggedInUser(updateUserRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update an Order
         * @param {string} id
         * @param {UpdateOrderRequest} updateOrderRequest Order Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrder(id, updateOrderRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateOrder(id, updateOrderRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a setup intent with a new payment method
         * @param {UpdateSetupIntentRequest} updateSetupIntentRequest Provide the setup intent and payment method IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSetupIntent(updateSetupIntentRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateSetupIntent(updateSetupIntentRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update the profile picture of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfileImage(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateUserProfileImage(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a User Status
         * @param {string} userId
         * @param {UpdateUserStatusRequest} updateUserStatusRequest Update User Status Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserStatus(userId, updateUserStatusRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateUserStatus(userId, updateUserStatusRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update Warehouse Image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWarehouseImage(id, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateWarehouseImage(id, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a warehouses
         * @param {string} id
         * @param {UpdateWarehouseRequest} [updateWarehouseRequest] Update warehouse object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWarehouses(id, updateWarehouseRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateWarehouses(id, updateWarehouseRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a workspace
         * @param {UpdateWorkspaceRequest} [updateWorkspaceRequest] Update workspace object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkspace(updateWorkspaceRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateWorkspace(updateWorkspaceRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update Workspace Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkspaceImage(options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateWorkspaceImage(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update Workspace User
         * @param {string} userId
         * @param {UpdateUserWorkspaceRequest} updateUserWorkspaceRequest Update Workspace User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkspaceUser(userId, updateUserWorkspaceRequest, options) {
            const localVarAxiosArgs = await (0, exports.TraceApiAxiosParamCreator)(configuration).updateWorkspaceUser(userId, updateUserWorkspaceRequest, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.TraceApiFp = TraceApiFp;
/**
 * TraceApi - factory interface
 * @export
 */
const TraceApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Add Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentImage(documentId, imageName, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).addDocumentImage(documentId, imageName, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a Widget to a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {DocumentWidgetEnum} widget The Widget to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentWidget(documentId, templateId, widget, options) {
            return (0, exports.TraceApiFp)(configuration).addDocumentWidget(documentId, templateId, widget, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin Add Workspace Trace Provider
         * @param {string} workspaceId ID of the Workspace
         * @param {AdminAddTraceProviderRequest} adminAddTraceProviderRequest Trace Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddWorkspaceTraceProvider(workspaceId, adminAddTraceProviderRequest, options) {
            return (0, exports.TraceApiFp)(configuration).adminAddWorkspaceTraceProvider(workspaceId, adminAddTraceProviderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary AdminGet All Workspaces
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetAllWorkspaces(limit, skip, options) {
            return (0, exports.TraceApiFp)(configuration).adminGetAllWorkspaces(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin Get Workspace
         * @param {string} workspaceId ID of the Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWorkspace(workspaceId, options) {
            return (0, exports.TraceApiFp)(configuration).adminGetWorkspace(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin Update Workspace
         * @param {string} workspaceId ID of the Workspace
         * @param {AdminUpdateWorkspaceRequest} adminUpdateWorkspaceRequest Updated Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWorkspace(workspaceId, adminUpdateWorkspaceRequest, options) {
            return (0, exports.TraceApiFp)(configuration).adminUpdateWorkspace(workspaceId, adminUpdateWorkspaceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Approve an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrder(id, options) {
            return (0, exports.TraceApiFp)(configuration).approveOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel the subscription for the workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(options) {
            return (0, exports.TraceApiFp)(configuration).cancelSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Clear a widget\'s data
         * @param {string} documentId Id of the document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ClearDocumentWidgetRequest} [clearDocumentWidgetRequest] An object containing the widget key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearDocumentWidget(documentId, templateId, clearDocumentWidgetRequest, options) {
            return (0, exports.TraceApiFp)(configuration).clearDocumentWidget(documentId, templateId, clearDocumentWidgetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirm Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmDocumentImageRequest} confirmDocumentImageRequest Confirm Document Image Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentImage(documentId, imageName, templateId, confirmDocumentImageRequest, options) {
            return (0, exports.TraceApiFp)(configuration).confirmDocumentImage(documentId, imageName, templateId, confirmDocumentImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirm a Widget on a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmDocumentWidgetRequest} confirmDocumentWidgetRequest Confirm Widget Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentWidget(documentId, templateId, confirmDocumentWidgetRequest, options) {
            return (0, exports.TraceApiFp)(configuration).confirmDocumentWidget(documentId, templateId, confirmDocumentWidgetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} documentId Document ID
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ConfirmUploadImageRequest} [confirmUploadImageRequest] Confirm data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmReliningImageUpload(documentId, templateId, confirmUploadImageRequest, options) {
            return (0, exports.TraceApiFp)(configuration).confirmReliningImageUpload(documentId, templateId, confirmUploadImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirm a User
         * @param {ConfirmUserRequest} confirmUserRequest User to be Confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUser(confirmUserRequest, options) {
            return (0, exports.TraceApiFp)(configuration).confirmUser(confirmUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Project
         * @param {string} id
         * @param {CreateClientProjectRequest} createClientProjectRequest Project to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientProject(id, createClientProjectRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createClientProject(id, createClientProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a Delivery
         * @param {CreateDeliveryRequest} createDeliveryRequest Delivery Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDelivery(createDeliveryRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createDelivery(createDeliveryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument(templateId, options) {
            return (0, exports.TraceApiFp)(configuration).createDocument(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an Item
         * @param {CreateItemRequest} createItemRequest Item Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createItem(createItemRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createItem(createItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an Order
         * @param {CreateOrderRequest} createOrderRequest Order Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(createOrderRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createOrder(createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a stripe free subscription
         * @param {CreatePaymentsFreeSubscriptionRequest} createPaymentsFreeSubscriptionRequest Create payments free subscription request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentsFreeSubscription(createPaymentsFreeSubscriptionRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createPaymentsFreeSubscription(createPaymentsFreeSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a stripe subscription
         * @param {CreatePaymentsSubscriptionRequest} createPaymentsSubscriptionRequest Create payments subscription request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentsSubscription(createPaymentsSubscriptionRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createPaymentsSubscription(createPaymentsSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a Warehouse
         * @param {CreateWarehouseRequest} createWarehouseRequest Warehouse Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWarehouse(createWarehouseRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createWarehouse(createWarehouseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a Workspace
         * @param {CreateWorkspaceRequest} createWorkspaceRequest Workspace Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspace(createWorkspaceRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createWorkspace(createWorkspaceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Workspace Clients
         * @param {CreateWorkspaceClientRequest} createWorkspaceClientRequest Workspace Client Object to be Created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceClient(createWorkspaceClientRequest, options) {
            return (0, exports.TraceApiFp)(configuration).createWorkspaceClient(createWorkspaceClientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDelivery(id, options) {
            return (0, exports.TraceApiFp)(configuration).deleteDelivery(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(documentId, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).deleteDocument(documentId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Widget from a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {string} widgetKey The Widget key to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentWidget(documentId, templateId, widgetKey, options) {
            return (0, exports.TraceApiFp)(configuration).deleteDocumentWidget(documentId, templateId, widgetKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an invited User
         * @param {DeleteInviteUserRequest} deleteInviteUserRequest The invited User to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitedUser(deleteInviteUserRequest, options) {
            return (0, exports.TraceApiFp)(configuration).deleteInvitedUser(deleteInviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrder(id, options) {
            return (0, exports.TraceApiFp)(configuration).deleteOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Finalize a Delivery
         * @param {string} id
         * @param {FinalizeDeliveryRequest} finalizeDeliveryRequest Delivery Object to be Finalized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeDelivery(id, finalizeDeliveryRequest, options) {
            return (0, exports.TraceApiFp)(configuration).finalizeDelivery(id, finalizeDeliveryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Finalize a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {FinalizeDocumentRequest} finalizeDocumentRequest Finalize Document Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeDocument(documentId, templateId, finalizeDocumentRequest, options) {
            return (0, exports.TraceApiFp)(configuration).finalizeDocument(documentId, templateId, finalizeDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Finalize an Order
         * @param {string} id
         * @param {FinalizeOrderRequest} finalizeOrderRequest Order to be finalized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeOrder(id, finalizeOrderRequest, options) {
            return (0, exports.TraceApiFp)(configuration).finalizeOrder(id, finalizeOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current active (default) payment method for the workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePaymentMethod(options) {
            return (0, exports.TraceApiFp)(configuration).getActivePaymentMethod(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Deliveries
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeliveries(limit, skip, options) {
            return (0, exports.TraceApiFp)(configuration).getAllDeliveries(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Documents
         * @param {number} [limit] Limits the number of elements returned
         * @param {string} [query] Text field result
         * @param {number} [skip] Skips a number of elements
         * @param {'true' | 'false'} [userOnly] Boolean to return user only Documents
         * @param {string | Array<string>} [statuses] Status of the documents to return
         * @param {'id' | 'status' | 'dateCreated' | 'dateUpdated' | 'dateFinished'} [sortBy]
         * @param {'ASC' | 'DESC'} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocuments(limit, query, skip, userOnly, statuses, sortBy, order, options) {
            return (0, exports.TraceApiFp)(configuration).getAllDocuments(limit, query, skip, userOnly, statuses, sortBy, order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All External Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllExternalUsers(options) {
            return (0, exports.TraceApiFp)(configuration).getAllExternalUsers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Items
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItems(limit, skip, options) {
            return (0, exports.TraceApiFp)(configuration).getAllItems(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Notifications
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications(limit, skip, options) {
            return (0, exports.TraceApiFp)(configuration).getAllNotifications(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Orders
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders(limit, skip, options) {
            return (0, exports.TraceApiFp)(configuration).getAllOrders(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTemplates(options) {
            return (0, exports.TraceApiFp)(configuration).getAllTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(options) {
            return (0, exports.TraceApiFp)(configuration).getAllUsers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all users with permissions for a particular template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersWithPermission(templateId, options) {
            return (0, exports.TraceApiFp)(configuration).getAllUsersWithPermission(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all the users without permission for a particular template
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersWithoutPermission(templateId, options) {
            return (0, exports.TraceApiFp)(configuration).getAllUsersWithoutPermission(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Warehouses
         * @param {number} [limit] Limits the number of elements returned
         * @param {number} [skip] Skips a number of elements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWarehouses(limit, skip, options) {
            return (0, exports.TraceApiFp)(configuration).getAllWarehouses(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the billing history for the current workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingHistory(options) {
            return (0, exports.TraceApiFp)(configuration).getBillingHistory(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get client projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientProjects(id, options) {
            return (0, exports.TraceApiFp)(configuration).getClientProjects(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelivery(id, options) {
            return (0, exports.TraceApiFp)(configuration).getDelivery(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Delivery Document
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryDocument(id, options) {
            return (0, exports.TraceApiFp)(configuration).getDeliveryDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(documentId, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).getDocument(documentId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Document Certificate
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentCertificate(documentId, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).getDocumentCertificate(documentId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Document Image
         * @param {string} documentId ID of the Document
         * @param {string} imageName Name of the Document Image
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentImage(documentId, imageName, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).getDocumentImage(documentId, imageName, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all recipients of a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentRecipients(documentId, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).getDocumentRecipients(documentId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Logged In User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoggedInUser(options) {
            return (0, exports.TraceApiFp)(configuration).getLoggedInUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get module prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulePrices(options) {
            return (0, exports.TraceApiFp)(configuration).getModulePrices(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(id, options) {
            return (0, exports.TraceApiFp)(configuration).getOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Order Document
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDocument(id, options) {
            return (0, exports.TraceApiFp)(configuration).getOrderDocument(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get payment discount percentages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentDiscounts(options) {
            return (0, exports.TraceApiFp)(configuration).getPaymentDiscounts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin get all projects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options) {
            return (0, exports.TraceApiFp)(configuration).getProjects(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} documentId Document ID
         * @param {string} templateId Template ID
         * @param {string} imageName The name of the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReliningUploadImageUrl(documentId, templateId, imageName, options) {
            return (0, exports.TraceApiFp)(configuration).getReliningUploadImageUrl(documentId, templateId, imageName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all running documents for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningDocumentsForUser(options) {
            return (0, exports.TraceApiFp)(configuration).getRunningDocumentsForUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get information about the subscription of a workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(options) {
            return (0, exports.TraceApiFp)(configuration).getSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the upcoming invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice(options) {
            return (0, exports.TraceApiFp)(configuration).getUpcomingInvoice(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get number of users for each template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersTemplates(options) {
            return (0, exports.TraceApiFp)(configuration).getUsersTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Warehouse
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseById(id, options) {
            return (0, exports.TraceApiFp)(configuration).getWarehouseById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Warehouse Inventory
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseInventory(id, options) {
            return (0, exports.TraceApiFp)(configuration).getWarehouseInventory(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Widget Upload Url
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {GetWidgetUploadUrlRequest} getWidgetUploadUrlRequest Get Widget Upload Url Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetUploadUrl(documentId, templateId, getWidgetUploadUrlRequest, options) {
            return (0, exports.TraceApiFp)(configuration).getWidgetUploadUrl(documentId, templateId, getWidgetUploadUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspace(options) {
            return (0, exports.TraceApiFp)(configuration).getWorkspace(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all Workspace Clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceClients(options) {
            return (0, exports.TraceApiFp)(configuration).getWorkspaceClients(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should gain permissions to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTemplatePermission(modifyPermissionRequest, options) {
            return (0, exports.TraceApiFp)(configuration).grantTemplatePermission(modifyPermissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Invite a User
         * @param {InviteUsersRequest} inviteUsersRequest User to be Invited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(inviteUsersRequest, options) {
            return (0, exports.TraceApiFp)(configuration).inviteUser(inviteUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {NotificationsMarkSeenRequest} [notificationsMarkSeenRequest] The IDs of the notifications which should be marked as seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsUserMarkSeen(userId, notificationsMarkSeenRequest, options) {
            return (0, exports.TraceApiFp)(configuration).notificationsUserMarkSeen(userId, notificationsMarkSeenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reactivate the subscription for the workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription(options) {
            return (0, exports.TraceApiFp)(configuration).reactivateSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reject a Delivery
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDelivery(id, options) {
            return (0, exports.TraceApiFp)(configuration).rejectDelivery(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reject an Order
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrder(id, options) {
            return (0, exports.TraceApiFp)(configuration).rejectOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliningTimerReset(documentId, templateId, options) {
            return (0, exports.TraceApiFp)(configuration).reliningTimerReset(documentId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ReliningTimerStartRequest} [reliningTimerStartRequest] Timestamp of when the user clicked the timer start button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliningTimerStart(documentId, templateId, reliningTimerStartRequest, options) {
            return (0, exports.TraceApiFp)(configuration).reliningTimerStart(documentId, templateId, reliningTimerStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {ReliningTimerStopRequest} [reliningTimerStopRequest] Timestamp of when the user clicked the timer stop button
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reliningTimerStop(documentId, templateId, reliningTimerStopRequest, options) {
            return (0, exports.TraceApiFp)(configuration).reliningTimerStop(documentId, templateId, reliningTimerStopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove external users from a workspace
         * @param {RemoveExternalUsersRequest} [removeExternalUsersRequest] The emails of the users that should be removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExternalUsers(removeExternalUsersRequest, options) {
            return (0, exports.TraceApiFp)(configuration).removeExternalUsers(removeExternalUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} documentId The document id
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {RemoveReliningImageRequest} [removeReliningImageRequest] Timestamp of when the user attempted to delete the image, the image name along with the object path to the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeReliningImage(documentId, templateId, removeReliningImageRequest, options) {
            return (0, exports.TraceApiFp)(configuration).removeReliningImage(documentId, templateId, removeReliningImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resend Invite to the User
         * @param {ResendInviteUserRequest} resendInviteUserRequest Resend Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvite(resendInviteUserRequest, options) {
            return (0, exports.TraceApiFp)(configuration).resendInvite(resendInviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should lose permissions to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTemplatePermission(modifyPermissionRequest, options) {
            return (0, exports.TraceApiFp)(configuration).revokeTemplatePermission(modifyPermissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a customer\'s payment method.
         * @param {UpdateCustomerPaymentMethod} updateCustomerPaymentMethod The payment method ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerPaymentMethod(updateCustomerPaymentMethod, options) {
            return (0, exports.TraceApiFp)(configuration).updateCustomerPaymentMethod(updateCustomerPaymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a Delivery
         * @param {string} id
         * @param {UpdateDeliveryRequest} updateDeliveryRequest Delivery Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDelivery(id, updateDeliveryRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateDelivery(id, updateDeliveryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a Document
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {UpdateDocumentRequest} updateDocumentRequest Updated Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument(documentId, templateId, updateDocumentRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateDocument(documentId, templateId, updateDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a Document Assignee
         * @param {string} documentId ID of the Document
         * @param {string} templateId ID of the Document\&#39;s template
         * @param {UpdateDocumentAssigneeRequest} updateDocumentAssigneeRequest Updated Document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentAssignee(documentId, templateId, updateDocumentAssigneeRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateDocumentAssignee(documentId, templateId, updateDocumentAssigneeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Item
         * @param {string} id
         * @param {UpdateItemRequest} updateItemRequest Item Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItem(id, updateItemRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateItem(id, updateItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Item Image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemImage(id, options) {
            return (0, exports.TraceApiFp)(configuration).updateItemImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Logged In User
         * @param {UpdateUserRequest} updateUserRequest Update Logged In User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoggedInUser(updateUserRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateLoggedInUser(updateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an Order
         * @param {string} id
         * @param {UpdateOrderRequest} updateOrderRequest Order Object to be Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder(id, updateOrderRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateOrder(id, updateOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a setup intent with a new payment method
         * @param {UpdateSetupIntentRequest} updateSetupIntentRequest Provide the setup intent and payment method IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSetupIntent(updateSetupIntentRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateSetupIntent(updateSetupIntentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update the profile picture of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfileImage(options) {
            return (0, exports.TraceApiFp)(configuration).updateUserProfileImage(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a User Status
         * @param {string} userId
         * @param {UpdateUserStatusRequest} updateUserStatusRequest Update User Status Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStatus(userId, updateUserStatusRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateUserStatus(userId, updateUserStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Warehouse Image
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWarehouseImage(id, options) {
            return (0, exports.TraceApiFp)(configuration).updateWarehouseImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a warehouses
         * @param {string} id
         * @param {UpdateWarehouseRequest} [updateWarehouseRequest] Update warehouse object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWarehouses(id, updateWarehouseRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateWarehouses(id, updateWarehouseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a workspace
         * @param {UpdateWorkspaceRequest} [updateWorkspaceRequest] Update workspace object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspace(updateWorkspaceRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateWorkspace(updateWorkspaceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Workspace Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceImage(options) {
            return (0, exports.TraceApiFp)(configuration).updateWorkspaceImage(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Workspace User
         * @param {string} userId
         * @param {UpdateUserWorkspaceRequest} updateUserWorkspaceRequest Update Workspace User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceUser(userId, updateUserWorkspaceRequest, options) {
            return (0, exports.TraceApiFp)(configuration).updateWorkspaceUser(userId, updateUserWorkspaceRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TraceApiFactory = TraceApiFactory;
/**
 * TraceApi - object-oriented interface
 * @export
 * @class TraceApi
 * @extends {BaseAPI}
 */
class TraceApi extends base_1.BaseAPI {
    /**
     *
     * @summary Add Document Image
     * @param {string} documentId ID of the Document
     * @param {string} imageName Name of the Document Image
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    addDocumentImage(documentId, imageName, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).addDocumentImage(documentId, imageName, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add a Widget to a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {DocumentWidgetEnum} widget The Widget to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    addDocumentWidget(documentId, templateId, widget, options) {
        return (0, exports.TraceApiFp)(this.configuration).addDocumentWidget(documentId, templateId, widget, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Admin Add Workspace Trace Provider
     * @param {string} workspaceId ID of the Workspace
     * @param {AdminAddTraceProviderRequest} adminAddTraceProviderRequest Trace Provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    adminAddWorkspaceTraceProvider(workspaceId, adminAddTraceProviderRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).adminAddWorkspaceTraceProvider(workspaceId, adminAddTraceProviderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary AdminGet All Workspaces
     * @param {number} [limit] Limits the number of elements returned
     * @param {number} [skip] Skips a number of elements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    adminGetAllWorkspaces(limit, skip, options) {
        return (0, exports.TraceApiFp)(this.configuration).adminGetAllWorkspaces(limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Admin Get Workspace
     * @param {string} workspaceId ID of the Workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    adminGetWorkspace(workspaceId, options) {
        return (0, exports.TraceApiFp)(this.configuration).adminGetWorkspace(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Admin Update Workspace
     * @param {string} workspaceId ID of the Workspace
     * @param {AdminUpdateWorkspaceRequest} adminUpdateWorkspaceRequest Updated Workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    adminUpdateWorkspace(workspaceId, adminUpdateWorkspaceRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).adminUpdateWorkspace(workspaceId, adminUpdateWorkspaceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Approve an Order
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    approveOrder(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).approveOrder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel the subscription for the workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    cancelSubscription(options) {
        return (0, exports.TraceApiFp)(this.configuration).cancelSubscription(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Clear a widget\'s data
     * @param {string} documentId Id of the document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {ClearDocumentWidgetRequest} [clearDocumentWidgetRequest] An object containing the widget key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    clearDocumentWidget(documentId, templateId, clearDocumentWidgetRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).clearDocumentWidget(documentId, templateId, clearDocumentWidgetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirm Document Image
     * @param {string} documentId ID of the Document
     * @param {string} imageName Name of the Document Image
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {ConfirmDocumentImageRequest} confirmDocumentImageRequest Confirm Document Image Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    confirmDocumentImage(documentId, imageName, templateId, confirmDocumentImageRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).confirmDocumentImage(documentId, imageName, templateId, confirmDocumentImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirm a Widget on a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {ConfirmDocumentWidgetRequest} confirmDocumentWidgetRequest Confirm Widget Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    confirmDocumentWidget(documentId, templateId, confirmDocumentWidgetRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).confirmDocumentWidget(documentId, templateId, confirmDocumentWidgetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} documentId Document ID
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {ConfirmUploadImageRequest} [confirmUploadImageRequest] Confirm data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    confirmReliningImageUpload(documentId, templateId, confirmUploadImageRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).confirmReliningImageUpload(documentId, templateId, confirmUploadImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirm a User
     * @param {ConfirmUserRequest} confirmUserRequest User to be Confirmed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    confirmUser(confirmUserRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).confirmUser(confirmUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Project
     * @param {string} id
     * @param {CreateClientProjectRequest} createClientProjectRequest Project to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createClientProject(id, createClientProjectRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createClientProject(id, createClientProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a Delivery
     * @param {CreateDeliveryRequest} createDeliveryRequest Delivery Object to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createDelivery(createDeliveryRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createDelivery(createDeliveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createDocument(templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).createDocument(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an Item
     * @param {CreateItemRequest} createItemRequest Item Object to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createItem(createItemRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createItem(createItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an Order
     * @param {CreateOrderRequest} createOrderRequest Order Object to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createOrder(createOrderRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createOrder(createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a stripe free subscription
     * @param {CreatePaymentsFreeSubscriptionRequest} createPaymentsFreeSubscriptionRequest Create payments free subscription request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createPaymentsFreeSubscription(createPaymentsFreeSubscriptionRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createPaymentsFreeSubscription(createPaymentsFreeSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a stripe subscription
     * @param {CreatePaymentsSubscriptionRequest} createPaymentsSubscriptionRequest Create payments subscription request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createPaymentsSubscription(createPaymentsSubscriptionRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createPaymentsSubscription(createPaymentsSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a Warehouse
     * @param {CreateWarehouseRequest} createWarehouseRequest Warehouse Object to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createWarehouse(createWarehouseRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createWarehouse(createWarehouseRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a Workspace
     * @param {CreateWorkspaceRequest} createWorkspaceRequest Workspace Object to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createWorkspace(createWorkspaceRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createWorkspace(createWorkspaceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Workspace Clients
     * @param {CreateWorkspaceClientRequest} createWorkspaceClientRequest Workspace Client Object to be Created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    createWorkspaceClient(createWorkspaceClientRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).createWorkspaceClient(createWorkspaceClientRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Delivery
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    deleteDelivery(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).deleteDelivery(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    deleteDocument(documentId, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).deleteDocument(documentId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Widget from a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {string} widgetKey The Widget key to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    deleteDocumentWidget(documentId, templateId, widgetKey, options) {
        return (0, exports.TraceApiFp)(this.configuration).deleteDocumentWidget(documentId, templateId, widgetKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an invited User
     * @param {DeleteInviteUserRequest} deleteInviteUserRequest The invited User to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    deleteInvitedUser(deleteInviteUserRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).deleteInvitedUser(deleteInviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an Order
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    deleteOrder(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).deleteOrder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Finalize a Delivery
     * @param {string} id
     * @param {FinalizeDeliveryRequest} finalizeDeliveryRequest Delivery Object to be Finalized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    finalizeDelivery(id, finalizeDeliveryRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).finalizeDelivery(id, finalizeDeliveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Finalize a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {FinalizeDocumentRequest} finalizeDocumentRequest Finalize Document Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    finalizeDocument(documentId, templateId, finalizeDocumentRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).finalizeDocument(documentId, templateId, finalizeDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Finalize an Order
     * @param {string} id
     * @param {FinalizeOrderRequest} finalizeOrderRequest Order to be finalized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    finalizeOrder(id, finalizeOrderRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).finalizeOrder(id, finalizeOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current active (default) payment method for the workspace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getActivePaymentMethod(options) {
        return (0, exports.TraceApiFp)(this.configuration).getActivePaymentMethod(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Deliveries
     * @param {number} [limit] Limits the number of elements returned
     * @param {number} [skip] Skips a number of elements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllDeliveries(limit, skip, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllDeliveries(limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Documents
     * @param {number} [limit] Limits the number of elements returned
     * @param {string} [query] Text field result
     * @param {number} [skip] Skips a number of elements
     * @param {'true' | 'false'} [userOnly] Boolean to return user only Documents
     * @param {string | Array<string>} [statuses] Status of the documents to return
     * @param {'id' | 'status' | 'dateCreated' | 'dateUpdated' | 'dateFinished'} [sortBy]
     * @param {'ASC' | 'DESC'} [order]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllDocuments(limit, query, skip, userOnly, statuses, sortBy, order, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllDocuments(limit, query, skip, userOnly, statuses, sortBy, order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get All External Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllExternalUsers(options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllExternalUsers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Items
     * @param {number} [limit] Limits the number of elements returned
     * @param {number} [skip] Skips a number of elements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllItems(limit, skip, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllItems(limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Notifications
     * @param {number} [limit] Limits the number of elements returned
     * @param {number} [skip] Skips a number of elements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllNotifications(limit, skip, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllNotifications(limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Orders
     * @param {number} [limit] Limits the number of elements returned
     * @param {number} [skip] Skips a number of elements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllOrders(limit, skip, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllOrders(limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllTemplates(options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllTemplates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllUsers(options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllUsers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all users with permissions for a particular template
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllUsersWithPermission(templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllUsersWithPermission(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all the users without permission for a particular template
     * @param {string} templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllUsersWithoutPermission(templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllUsersWithoutPermission(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Warehouses
     * @param {number} [limit] Limits the number of elements returned
     * @param {number} [skip] Skips a number of elements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getAllWarehouses(limit, skip, options) {
        return (0, exports.TraceApiFp)(this.configuration).getAllWarehouses(limit, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the billing history for the current workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getBillingHistory(options) {
        return (0, exports.TraceApiFp)(this.configuration).getBillingHistory(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get client projects
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getClientProjects(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getClientProjects(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Delivery
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getDelivery(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getDelivery(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Delivery Document
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getDeliveryDocument(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getDeliveryDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getDocument(documentId, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).getDocument(documentId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Document Certificate
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getDocumentCertificate(documentId, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).getDocumentCertificate(documentId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Document Image
     * @param {string} documentId ID of the Document
     * @param {string} imageName Name of the Document Image
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getDocumentImage(documentId, imageName, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).getDocumentImage(documentId, imageName, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all recipients of a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getDocumentRecipients(documentId, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).getDocumentRecipients(documentId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Logged In User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getLoggedInUser(options) {
        return (0, exports.TraceApiFp)(this.configuration).getLoggedInUser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get module prices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getModulePrices(options) {
        return (0, exports.TraceApiFp)(this.configuration).getModulePrices(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Order
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getOrder(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getOrder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Order Document
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getOrderDocument(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getOrderDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get payment discount percentages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getPaymentDiscounts(options) {
        return (0, exports.TraceApiFp)(this.configuration).getPaymentDiscounts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Admin get all projects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getProjects(options) {
        return (0, exports.TraceApiFp)(this.configuration).getProjects(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} documentId Document ID
     * @param {string} templateId Template ID
     * @param {string} imageName The name of the image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getReliningUploadImageUrl(documentId, templateId, imageName, options) {
        return (0, exports.TraceApiFp)(this.configuration).getReliningUploadImageUrl(documentId, templateId, imageName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all running documents for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getRunningDocumentsForUser(options) {
        return (0, exports.TraceApiFp)(this.configuration).getRunningDocumentsForUser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get information about the subscription of a workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getSubscription(options) {
        return (0, exports.TraceApiFp)(this.configuration).getSubscription(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the upcoming invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getUpcomingInvoice(options) {
        return (0, exports.TraceApiFp)(this.configuration).getUpcomingInvoice(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get number of users for each template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getUsersTemplates(options) {
        return (0, exports.TraceApiFp)(this.configuration).getUsersTemplates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Warehouse
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getWarehouseById(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getWarehouseById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Warehouse Inventory
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getWarehouseInventory(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).getWarehouseInventory(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Widget Upload Url
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {GetWidgetUploadUrlRequest} getWidgetUploadUrlRequest Get Widget Upload Url Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getWidgetUploadUrl(documentId, templateId, getWidgetUploadUrlRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).getWidgetUploadUrl(documentId, templateId, getWidgetUploadUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a Workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getWorkspace(options) {
        return (0, exports.TraceApiFp)(this.configuration).getWorkspace(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all Workspace Clients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    getWorkspaceClients(options) {
        return (0, exports.TraceApiFp)(this.configuration).getWorkspaceClients(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should gain permissions to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    grantTemplatePermission(modifyPermissionRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).grantTemplatePermission(modifyPermissionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Invite a User
     * @param {InviteUsersRequest} inviteUsersRequest User to be Invited
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    inviteUser(inviteUsersRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).inviteUser(inviteUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userId
     * @param {NotificationsMarkSeenRequest} [notificationsMarkSeenRequest] The IDs of the notifications which should be marked as seen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    notificationsUserMarkSeen(userId, notificationsMarkSeenRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).notificationsUserMarkSeen(userId, notificationsMarkSeenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reactivate the subscription for the workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    reactivateSubscription(options) {
        return (0, exports.TraceApiFp)(this.configuration).reactivateSubscription(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reject a Delivery
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    rejectDelivery(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).rejectDelivery(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reject an Order
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    rejectOrder(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).rejectOrder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} documentId The document id
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    reliningTimerReset(documentId, templateId, options) {
        return (0, exports.TraceApiFp)(this.configuration).reliningTimerReset(documentId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} documentId The document id
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {ReliningTimerStartRequest} [reliningTimerStartRequest] Timestamp of when the user clicked the timer start button
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    reliningTimerStart(documentId, templateId, reliningTimerStartRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).reliningTimerStart(documentId, templateId, reliningTimerStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} documentId The document id
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {ReliningTimerStopRequest} [reliningTimerStopRequest] Timestamp of when the user clicked the timer stop button
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    reliningTimerStop(documentId, templateId, reliningTimerStopRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).reliningTimerStop(documentId, templateId, reliningTimerStopRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove external users from a workspace
     * @param {RemoveExternalUsersRequest} [removeExternalUsersRequest] The emails of the users that should be removed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    removeExternalUsers(removeExternalUsersRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).removeExternalUsers(removeExternalUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} documentId The document id
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {RemoveReliningImageRequest} [removeReliningImageRequest] Timestamp of when the user attempted to delete the image, the image name along with the object path to the image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    removeReliningImage(documentId, templateId, removeReliningImageRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).removeReliningImage(documentId, templateId, removeReliningImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resend Invite to the User
     * @param {ResendInviteUserRequest} resendInviteUserRequest Resend Invite Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    resendInvite(resendInviteUserRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).resendInvite(resendInviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ModifyPermissionRequest} [modifyPermissionRequest] The ID of the user and the template which that user should lose permissions to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    revokeTemplatePermission(modifyPermissionRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).revokeTemplatePermission(modifyPermissionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a customer\'s payment method.
     * @param {UpdateCustomerPaymentMethod} updateCustomerPaymentMethod The payment method ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateCustomerPaymentMethod(updateCustomerPaymentMethod, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateCustomerPaymentMethod(updateCustomerPaymentMethod, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a Delivery
     * @param {string} id
     * @param {UpdateDeliveryRequest} updateDeliveryRequest Delivery Object to be Updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateDelivery(id, updateDeliveryRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateDelivery(id, updateDeliveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a Document
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {UpdateDocumentRequest} updateDocumentRequest Updated Document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateDocument(documentId, templateId, updateDocumentRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateDocument(documentId, templateId, updateDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a Document Assignee
     * @param {string} documentId ID of the Document
     * @param {string} templateId ID of the Document\&#39;s template
     * @param {UpdateDocumentAssigneeRequest} updateDocumentAssigneeRequest Updated Document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateDocumentAssignee(documentId, templateId, updateDocumentAssigneeRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateDocumentAssignee(documentId, templateId, updateDocumentAssigneeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Item
     * @param {string} id
     * @param {UpdateItemRequest} updateItemRequest Item Object to be Updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateItem(id, updateItemRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateItem(id, updateItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Item Image
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateItemImage(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateItemImage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Logged In User
     * @param {UpdateUserRequest} updateUserRequest Update Logged In User Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateLoggedInUser(updateUserRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateLoggedInUser(updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an Order
     * @param {string} id
     * @param {UpdateOrderRequest} updateOrderRequest Order Object to be Updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateOrder(id, updateOrderRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateOrder(id, updateOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a setup intent with a new payment method
     * @param {UpdateSetupIntentRequest} updateSetupIntentRequest Provide the setup intent and payment method IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateSetupIntent(updateSetupIntentRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateSetupIntent(updateSetupIntentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update the profile picture of a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateUserProfileImage(options) {
        return (0, exports.TraceApiFp)(this.configuration).updateUserProfileImage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a User Status
     * @param {string} userId
     * @param {UpdateUserStatusRequest} updateUserStatusRequest Update User Status Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateUserStatus(userId, updateUserStatusRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateUserStatus(userId, updateUserStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Warehouse Image
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateWarehouseImage(id, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateWarehouseImage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a warehouses
     * @param {string} id
     * @param {UpdateWarehouseRequest} [updateWarehouseRequest] Update warehouse object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateWarehouses(id, updateWarehouseRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateWarehouses(id, updateWarehouseRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a workspace
     * @param {UpdateWorkspaceRequest} [updateWorkspaceRequest] Update workspace object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateWorkspace(updateWorkspaceRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateWorkspace(updateWorkspaceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Workspace Image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateWorkspaceImage(options) {
        return (0, exports.TraceApiFp)(this.configuration).updateWorkspaceImage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Workspace User
     * @param {string} userId
     * @param {UpdateUserWorkspaceRequest} updateUserWorkspaceRequest Update Workspace User Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceApi
     */
    updateWorkspaceUser(userId, updateUserWorkspaceRequest, options) {
        return (0, exports.TraceApiFp)(this.configuration).updateWorkspaceUser(userId, updateUserWorkspaceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TraceApi = TraceApi;
//# sourceMappingURL=api.js.map